import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  getFinalDay,
  updateSingleDayShift,
  updateSpecificDay,
} from '@src/helpers/shiftHelpers'
import { TDay, TSingleDayShift } from '@src/helpers/shiftHelpers/types'
import { SHIFT_DATE_FORMAT } from '@src/helpers/timeAndDateHelpers/constants'
import { SHIFT_TYPE } from '@src/models/Shift'
import { format } from 'date-fns'
import { FormikProps } from 'formik'

export const handleHourChange = (
  value: string,
  formik: FormikProps<IScheduleSectionFormValues>,
  day: TSingleDayShift | TDay,
  isStartHour: boolean,
) => {
  const {
    values: { days, single_day_shifts, type },
    setFieldValue,
  } = formik
  const { id } = day

  if (type === SHIFT_TYPE.SINGLEDAY) {
    setFieldValue(
      'single_day_shifts',
      updateSingleDayShift(single_day_shifts, String(id), {
        [isStartHour ? 'hour_start' : 'hour_end']: value,
      }),
    )
  }

  if (type === SHIFT_TYPE.MULTIDAY && 'day_start' in day) {
    // Only update multiday days if this is a TDay (has day_start property)

    const dayEnd = getFinalDay(
      day.day_start,
      isStartHour ? value : day.hour_start,
      isStartHour ? day.hour_end : value,
    )
    const updatedDays = updateSpecificDay(days, Number(id), {
      [isStartHour ? 'hour_start' : 'hour_end']: value,
      day_end: dayEnd,
      date_end: format(dayEnd, SHIFT_DATE_FORMAT),
      is_dirty: true,
    })

    setFieldValue('days', updatedDays)
  }
}
